/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckActionNeededCreditApplicationsCount_creditApplicationsPaginated_CreditApplicationPaginatedConnection = { readonly __typename: 'CreditApplicationPaginatedConnection', readonly totalCount: number | null };

export type CheckActionNeededCreditApplicationsCount_Query = { readonly __typename: 'Query', readonly creditApplicationsPaginated: CheckActionNeededCreditApplicationsCount_creditApplicationsPaginated_CreditApplicationPaginatedConnection | null };


export type CheckActionNeededCreditApplicationsCountVariables = _Types.Exact<{ [key: string]: never; }>;


export type CheckActionNeededCreditApplicationsCount = CheckActionNeededCreditApplicationsCount_Query;


export const CheckActionNeededCreditApplicationsCountDocument = gql`
    query CheckActionNeededCreditApplicationsCount {
  creditApplicationsPaginated(first: 1, category: ACTION_NEEDED) {
    totalCount
  }
}
    `;

/**
 * __useCheckActionNeededCreditApplicationsCount__
 *
 * To run a query within a React component, call `useCheckActionNeededCreditApplicationsCount` and pass it any options that fit your needs.
 * When your component renders, `useCheckActionNeededCreditApplicationsCount` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckActionNeededCreditApplicationsCount({
 *   variables: {
 *   },
 * });
 */
export function useCheckActionNeededCreditApplicationsCount(baseOptions?: Apollo.QueryHookOptions<CheckActionNeededCreditApplicationsCount, CheckActionNeededCreditApplicationsCountVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckActionNeededCreditApplicationsCount, CheckActionNeededCreditApplicationsCountVariables>(CheckActionNeededCreditApplicationsCountDocument, options);
      }
export function useCheckActionNeededCreditApplicationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckActionNeededCreditApplicationsCount, CheckActionNeededCreditApplicationsCountVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckActionNeededCreditApplicationsCount, CheckActionNeededCreditApplicationsCountVariables>(CheckActionNeededCreditApplicationsCountDocument, options);
        }
export function useCheckActionNeededCreditApplicationsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckActionNeededCreditApplicationsCount, CheckActionNeededCreditApplicationsCountVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckActionNeededCreditApplicationsCount, CheckActionNeededCreditApplicationsCountVariables>(CheckActionNeededCreditApplicationsCountDocument, options);
        }
export type CheckActionNeededCreditApplicationsCountHookResult = ReturnType<typeof useCheckActionNeededCreditApplicationsCount>;
export type CheckActionNeededCreditApplicationsCountLazyQueryHookResult = ReturnType<typeof useCheckActionNeededCreditApplicationsCountLazyQuery>;
export type CheckActionNeededCreditApplicationsCountSuspenseQueryHookResult = ReturnType<typeof useCheckActionNeededCreditApplicationsCountSuspenseQuery>;
export type CheckActionNeededCreditApplicationsCountQueryResult = Apollo.QueryResult<CheckActionNeededCreditApplicationsCount, CheckActionNeededCreditApplicationsCountVariables>;